<template>
  <a-row :gutter="10">
    <a-col :md="leftColMd" :sm="24" style="margin-bottom: 20px">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <div class="div-query-banner">
              <a-col :xl="4" :lg="7" :md="8" :sm="24">
                <a-form-item label="基地">
                  <a-select placeholder="请选择基地" v-model="queryParam.baseId" @select="baseSelectSelect">
                    <a-select-option v-for="item in baseOptions" :value="item.id" :key="item.id">{{
                      item.text
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="4" :lg="7" :md="8" :sm="24">
                <a-form-item label="部门">
                  <a-select placeholder="请选择部门" v-model="queryParam.departId" @select="departSelectSelect">
                    <a-select-option v-for="item in departOptions" :value="item.id" :key="item.id">{{
                      item.text
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="4" :lg="7" :md="8" :sm="24">
                <a-form-item label="车间">
                  <a-select placeholder="请选择车间" v-model="queryParam.workshopId">
                    <a-select-option v-for="item in workshopOptions" :value="item.id" :key="item.id">{{
                      item.text
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="4" :lg="7" :md="8" :sm="24">
                <a-form-item label="是否启用">
                  <j-dict-select-tag
                    v-model="queryParam.status"
                    dictCode="depart_status"
                    placeholder="请选择是否启用"
                  />
                </a-form-item>
              </a-col>
              <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button class="query-banner-btn" type="primary" @click="searchReset" icon="reload">重置</a-button>
            </div>
          </a-form>
        </div>
        <!-- 查询区域-END -->
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus" class="add-group-btn">新增</a-button>
          <!-- <a-button type="primary" icon="download" @click="handleExportXls('巡检部门配置表')">导出</a-button>
          <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="import">导入</a-button>
          </a-upload> -->
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
            </a-menu>
            <!-- <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button> -->
          </a-dropdown>
        </div>

        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"> </i> 已选择
          <a
            ><i>{{ selectedRowKeys1.length }}</i></a
          >项
          <a style="margin-left: 24px" @click="onClearSelected1">清空</a>
        </div>

        <div style="margin-top: 15px">
          <a-table
            style="height: 500px"
            ref="table"
            size="middle"
            bordered
            rowKey="roleId"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :customRow="customTable1"
            @change="handleTableChange"
          >
            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>
            <template slot="imgSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
              <img
                v-else
                :src="getImgView(text)"
                height="25px"
                alt="图片不存在"
                style="max-width: 80px; font-size: 12px; font-style: italic"
              />
            </template>
            <template slot="fileSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
              <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
                下载
              </a-button>
            </template>

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>

              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除该小组吗?" @confirm="() => handleDelete(record.id, 'group')">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
            <!-- <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down"/>
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handlePerssion(record.id)">授权</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="handleEdit(record)">编辑</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete1(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown> -->
          </a-table>
        </div>
        <!-- 右侧的角色权限配置 -->
        <!-- <user-role-modal ref="modalUserRole"></user-role-modal> -->
        <!-- <role-modal ref="modalForm" @ok="modalFormOk"></role-modal> -->
      </a-card>
    </a-col>
    <a-col :md="rightColMd" :sm="24" v-if="this.rightcolval == 1">
      <a-card :bordered="false">
        <div style="text-align: right">
          <a-icon type="close-circle" @click="hideUserList" />
        </div>
        <!-- 查询区域 -->
        <!-- <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">

              <a-col :md="12" :sm="12">
                <a-form-item label="用户账号">
                  <a-input placeholder="" v-model="queryParam2.username"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="9" :sm="24">
             <a-button type="primary" @click="searchQuery2" icon="search" style="margin-left: 21px">查询</a-button>
              <a-button type="primary" @click="searchReset2" icon="reload" style="margin-left: 8px">重置</a-button>

            </a-col>
          </span>
            </a-row>
          </a-form>
        </div> -->
        <!-- 操作按钮区域 -->
        <div class="table-operator" :md="24" :sm="24" style="margin: -25px 0px 10px 2px">
          <!-- <a-button @click="handleAdd2" type="primary" icon="plus" style="margin-top: 16px">用户录入</a-button> -->
          <!--<a-button @click="handleEdit2" type="primary" icon="edit" style="margin-top: 16px">用户编辑</a-button>-->
          <a-button @click="handleAddUserRole" type="primary" icon="plus" style="margin-top: 16px"
            >添加已有人员到该小组</a-button
          >

          <a-dropdown v-if="selectedRowKeys2.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel2">
                <a-icon type="delete" />
                删除
              </a-menu-item>
            </a-menu>
            <!-- <a-button style="margin-left: 8px"> 批量操作
              <a-icon type="down"/>
            </a-button> -->
          </a-dropdown>
        </div>
        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
            <a style="font-weight: 600">{{ selectedRowKeys2.length }}</a
            >项
            <a style="margin-left: 24px" @click="onClearSelected2">清空</a>
          </div>
          <a-table
            style="height: 500px"
            ref="table2"
            bordered
            size="middle"
            rowKey="id"
            :columns="columns2"
            :dataSource="dataSource2"
            :pagination="ipagination2"
            :loading="loading2"
            @change="handleTableChange2"
          >
            <!-- <span slot="action" slot-scope="text, record">
            <a @click="handleConfig2(record)"  v-if="roleCodeChoose!='inspectionAdminXiamen'&&roleCodeChoose!='inspectionAdminSiyang'&&roleCodeChoose!='business_siyang'&&roleCodeChoose!='business_xiamen'&&roleCodeChoose!='5S_xiamen'&&roleCodeChoose!='5S_siyang'"  >配置</a>
            <a-divider type="vertical"   v-if="roleCodeChoose!='inspectionAdminXiamen'&&roleCodeChoose!='inspectionAdminSiyang'&&roleCodeChoose!='business_siyang'&&roleCodeChoose!='business_xiamen'&&roleCodeChoose!='5S_xiamen'&&roleCodeChoose!='5S_siyang'"  />
            <a @click="handleEdit2(record)"  v-if="roleCodeChoose!='inspectionAdminXiamen'&&roleCodeChoose!='inspectionAdminSiyang'&&roleCodeChoose!='business_siyang'&&roleCodeChoose!='business_xiamen'"  >车间</a>
            <a-divider type="vertical"   v-if="roleCodeChoose!='inspectionAdminXiamen'&&roleCodeChoose!='inspectionAdminSiyang'&&roleCodeChoose!='business_siyang'&&roleCodeChoose!='business_xiamen'"  />
            <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down"/>
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a-popconfirm :title="isSpecialrole?'确定删除吗':'该用户已配置的巡查车间将一并删除，确定吗?'" @confirm="() => handleDelete2(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
        </span> -->
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit2(record)">编辑</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除该组员吗?" @confirm="() => handleDelete(record.id, 'member')">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </div>
        <!-- 表单区域 -->
        <group-modal ref="modalForm" @ok="modalFormOk"></group-modal>
        <select-group-member-modal ref="selectGroupMemberModal" @selectFinished="selectOK"></select-group-member-modal>
        <group-member-modal ref="groupMemberModal" @editMemberOk="editMemberOk"></group-member-modal>
        <user-modal @refreshTable="loadData2" ref="modalForm2" @ok="modalFormOk2"></user-modal>
        <user-workshop-modal ref="userWorkshopModal"></user-workshop-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteAction, postAction, getAction } from '@/api/manage'
import GroupModal from './modules/GroupModal'
import SelectGroupMemberModal from './modules/SelectGroupMemberModal'
import GroupMemberModal from './modules/GroupMemberModal'
// import SelectUserModal from './modules/SelectUserModal'
import UserWorkshopModal from './modules/UserWorkshopModal.vue'
import RoleModal from './modules/RoleModal'
import UserModal from './modules/UserModal'
import { filterObj } from '@/utils/util'
import UserRoleModal from './modules/UserRoleModal'
import moment from 'moment'
import pick from 'lodash.pick'

export default {
  name: 'RoleUserList',
  mixins: [JeecgListMixin],
  components: {
    UserRoleModal,
    GroupModal,
    SelectGroupMemberModal,
    GroupMemberModal,
    // SelectUserModal,
    RoleModal,
    UserModal,
    moment,
    UserWorkshopModal,
  },
  data() {
    return {
      roleTypeChoose: '',
      roleCodeChoose: '',
      model1: {},
      model2: {},
      currentRoleId: '',
      queryParam1: {},
      queryParam2: {},
      dataSource1: [],
      dataSource2: [],
      ipagination1: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      ipagination2: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      isorter1: {
        column: 'createTime',
        order: 'desc',
      },
      isorter2: {
        column: 'createTime',
        order: 'desc',
      },
      filters1: {},
      filters2: {},
      loading1: false,
      loading2: false,
      selectedRowKeys1: [],
      selectedRowKeys2: [],
      selectionRows1: [],
      selectionRows2: [],
      test: {},
      rightcolval: 1,
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '小组名称',
          align: 'center',
          dataIndex: 'groupName',
        },
        {
          title: '基地',
          align: 'center',
          dataIndex: 'baseId_dictText',
        },
        {
          title: '部门',
          align: 'center',
          dataIndex: 'departId_dictText',
        },
        {
          title: '车间',
          align: 'center',
          dataIndex: 'workshopId_dictText',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      columns2: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 50,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '人员名称',
          align: 'center',
          width: 100,
          dataIndex: 'workerName',
        },
        {
          title: '人员角色',
          align: 'center',
          width: 100,
          dataIndex: 'workerRole_dictText',
        },
        {
          title: '人员工号',
          align: 'center',
          width: 100,
          dataIndex: 'workerNo',
        },
        {
          title: '禁用状态',
          align: 'center',
          width: 100,
          dataIndex: 'delFlag_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 120,
        },
      ],
      dictOptions: {},
      workshopOptions: [],
      baseOptions: [],
      departOptions: [],
      chooseRowId: '',
      chooseRow: {},

      url: {
        list: '/workshop/busInspectionWorkshopGroup/list',
        deleteGroup: '/workshop/busInspectionWorkshopGroup/delete',
        deleteBatch: '/workshop/busInspectionWorkshopGroup/deleteBatch',
        exportXlsUrl: '/workshop/busInspectionWorkshopGroup/exportXls',
        importExcelUrl: 'workshop/busInspectionWorkshopGroup/importExcel',

        list2: '/standardTeam/worker/list',
        add: '/standardTeam/worker/add',
        deleteMember: '/standardTeam/worker/delete',
        addUserRole: '/sys/user/addSysUserRole',
        delete2: '/inspection/role/deleteUserRole',
        deleteBatch2: '/inspection/role/deleteUserRoleBatch',
        groupId: '',
      },
      customTable1: (record) => {
        return {
          on: {
            // 事件
            click: (event) => {
              this.handleOpen(record)
            },
          },
        }
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    leftColMd() {
      return this.selectedRowKeys1.length === 0 ? 24 : 12
    },
    rightColMd() {
      return this.selectedRowKeys1.length === 0 ? 0 : 12
    },
    isSpecialrole() {
      if (
        this.roleCodeChoose != 'inspectionAdminXiamen' &&
        this.roleCodeChoose != 'inspectionAdminSiyang' &&
        this.roleCodeChoose != 'business_siyang' &&
        this.roleCodeChoose != 'business_xiamen'
      ) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    getAction('/standardTeam/task/getBaseDepartWorkshop', {}).then((res) => {
      if (res.code == 200) {
        this.baseOptions = res.result
      }
    })
  },
  methods: {
    baseSelectSelect(value, options) {
      this.departOptions = []
      this.workshopOptions = []
      this.$set(this.queryParam, 'depart', '')
      this.$set(this.queryParam, 'workshop', '')
      this.baseOptions.some((item) => {
        if (item.id == value) {
          this.departOptions = item.children
          return true
        }
      })
      this.queryParam.departId = undefined
      if (this.queryParam.workshopId) {
        this.queryParam.workshopId = undefined
      }
    },
    departSelectSelect(value, options) {
      this.workshopOptions = []
      this.$set(this.queryParam, 'workshop', '')
      this.departOptions.some((item) => {
        if (item.id == value) {
          this.workshopOptions = item.children
          return true
        }
      })
      if (this.queryParam.workshopId) {
        this.queryParam.workshopId = undefined
      }
      console.log('workshopOptions', this.workshopOptions)
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
    },
    editMemberOk: function (record) {
      this.loadData2()
    },
    handleAdd: function () {
      // console.log('queryParam',this.queryParam)
      // console.log('baseId',this.queryParam.baseId)
      // console.log('modalForm',this.$refs.modalForm)
      console.log(this.baseOptions)
      console.log(this.departOptions)
      if (!this.queryParam.baseId) {
        this.$message.error('添加小組前请先选择基地，部门和车间!')
        return
      }
      if (!this.queryParam.departId) {
        this.$message.error('添加小組前请先选择部门和车间!')
        return
      }
      if (!this.queryParam.workshopId) {
        this.$message.error('添加小組前请先选择车间!')
        return
      }
      this.rightcolval = 1
      let baseId = this.queryParam.baseId ? this.queryParam.baseId : ''
      let record = this.queryParam
      this.$refs.modalForm.add(record)
      // this.$refs.modalForm.title = "新增";
      // this.$refs.modalForm.disableSubmit = false;
    },
    onSelectChange2(selectedRowKeys, selectionRows) {
      console.log('selectionRows', selectedRowKeys, selectionRows)
      this.selectedRowKeys2 = selectedRowKeys
      this.selectionRows2 = selectionRows
    },
    onClearSelected2() {
      this.selectedRowKeys2 = []
      this.selectionRows2 = []
    },
    onClearSelected1() {
      this.selectedRowKeys1 = []
      this.selectionRows1 = []
    },
    onSelectChange1(selectedRowKeys, selectionRows) {
      // this.rightcolval = 1
      // this.selectionRows1 = selectionRows
      // this.model1 = Object.assign({}, selectionRows[0])
      // console.log(this.model1)
      // this.currentRoleId = selectedRowKeys[0]
      this.handleOpen(selectionRows[0])
    },
    onClearSelected() {},
    getQueryParams2() {
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams2) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams2)
      }
      var param = Object.assign(sqp, this.queryParam2, this.isorter2, this.filters2)
      param.field = this.getQueryField2()
      param.pageNo = this.ipagination2.current
      param.pageSize = this.ipagination2.pageSize
      return filterObj(param)
    },
    getQueryField2() {
      //TODO 字段权限控制
      var str = 'id,'
      this.columns2.forEach(function (value) {
        str += ',' + value.dataIndex
      })
      return str
    },
    handleEdit2(record) {
      this.$refs.groupMemberModal.title = '编辑组员'
      this.$refs.groupMemberModal.visible = true
      this.$refs.groupMemberModal.edit(record)
      // this.$refs.groupMemberModal.open(record,this.roleTypeChoose?this.roleTypeChoose:"",this.roleCodeChoose?this.roleCodeChoose:"",this.currentRoleId)
    },
    handleConfig2(record) {
      let ObjTemp = Object.assign(
        record,
        pick(
          this.selectionRows1[0],
          'roleId',
          'planType',
          'roleType',
          'roleName',
          'description',
          'roleCode',
          'hasNoon',
          'hasTemporaryTasks'
        )
      )
      ObjTemp.roleConfigId = this.selectionRows1[0].id
      this.$refs.modalForm2.edit(ObjTemp)
      this.$refs.modalForm2.title = '配置'
      this.$refs.modalForm2.disableSubmit = false
    },
    modalFormOk2() {
      // 新增/修改 成功时，重载列表
      this.loadData2()
    },
    loadData2(arg) {
      if (!this.url.list2) {
        this.$message.error('请设置url.list2属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination2.current = 1
      }
      // if (this.currentRoleId === '') return
      // let params = this.getQueryParams2()//查询条件
      // params.roleId = this.currentRoleId
      this.loading2 = true
      getAction(this.url.list2, { groupId: this.groupId }).then((res) => {
        if (res.success) {
          this.dataSource2 = res.result.records
          this.ipagination2.total = res.result.total
          console.log('dataSource2', this.dataSource2)
        }
        this.loading2 = false
      })
    },
    handleDelete: function (id, type) {
      this.handleDeleteEvent(id, type)
      this.dataSource2 = []
      this.currentRoleId = ''
    },
    handleDeleteEvent: function (id, type) {
      let curDeleteUrl = ''
      if (type === 'group') {
        curDeleteUrl = this.url.deleteGroup
      } else {
        curDeleteUrl = this.url.deleteMember
      }
      deleteAction(curDeleteUrl, { id: id }).then((res) => {
        if (res.success) {
          if (type === 'group') {
            console.log('删除小组')
            getAction(this.url.list, this.queryParam).then((res) => {
              if (res.success) {
                this.dataSource = res.result.records
                this.ipagination.total = res.result.total
              }
              this.loading2 = false
            })
          } else {
            console.log('删除组员')
            this.loadData2(1)
          }
          this.$message.success(res.message)
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    handleDelete2: function (id) {
      let delete2 = ''
      if (!this.isSpecialrole) {
        delete2 = '/inspection/role/deleteUserRole'
      } else {
        delete2 = '/sys/user/deleteUserRole'
      }
      deleteAction(delete2, { roleId: this.currentRoleId, userId: id }).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData2()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    batchDel2: function () {
      if (this.selectedRowKeys2.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys2.length; a++) {
          ids += this.selectedRowKeys2[a] + ','
        }
        let deleteBatch2 = ''
        if (!this.isSpecialrole) {
          deleteBatch2 = '/inspection/role/deleteUserRoleBatch'
        } else {
          deleteBatch2 = '/sys/user/deleteUserRoleBatch'
        }
        console.log(this.currentDeptId)
        this.$antdConfirm({
          title: '确认删除',
          content: this.isSpecialrole ? '确定删除吗' : '该用户已配置的巡查车间将一并删除，确定吗?',
          onOk: () => {
            deleteAction(deleteBatch2, { roleId: this.currentRoleId, userIds: ids }).then((res) => {
              if (res.success) {
                this.$message.success(res.message)
                this.loadData2()
                this.onClearSelected()
              } else {
                this.$message.warning(res.message)
              }
            })
          },
        })
      }
    },
    selectOK(data) {
      console.log(data)
      let params = {}
      params.groupId = this.groupId
      params.workerName = data[0].realname
      params.workerNo = data[0].workNo
      params.workerRole = 'group_leader'
      params.delFlag = 0
      console.log(params)
      postAction(this.url.add, params).then((res) => {
        if (res.success) {
          this.loadData2()
          this.$message.success(res.message)
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    handleAddUserRole() {
      console.log(this.currentRoleId)
      if (this.currentRoleId == '') {
        this.$message.error('请选择一个角色!')
      } else {
        this.$refs.selectGroupMemberModal.visible = true
        // this.$refs.selectUserModal.visible = true
      }
    },
    handleOpen(record) {
      console.log(record)
      console.log(record.id)
      this.groupId = record.id
      this.rightcolval = 1
      this.selectedRowKeys1 = [record.roleId]
      this.selectionRows1 = [record]
      this.currentRoleId = record.roleId
      // this.model1 = Object.assign({}, record)
      // this.roleTypeChoose=record.roleType
      // this.roleCodeChoose=record.roleCode
      // this.onClearSelected2()
      this.loadData2(1)
    },
    /*handleEdit: function(record) {
        if (this.currentRoleId == '') {
          this.$message.error('请选择一个角色!')
        } else {
          this.$refs.modalForm.edit(record)
          this.$refs.modalForm.title = '编辑'
        }
      },*/
    searchQuery2() {
      this.loadData2(1)
    },
    searchReset2() {
      this.queryParam2 = {}
      this.loadData2(1)
    },
    handleTableChange2(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter2.column = sorter.field
        this.isorter2.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      this.ipagination2 = pagination
      this.loadData2()
    },
    hideUserList() {
      //this.rightcolval = 0
      this.selectedRowKeys1 = []
    },
    handlePerssion(roleId) {
      this.$refs.modalUserRole.show(roleId)
    },
  },
}
</script>
<style scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 8px;
}
.table-operator {
  margin-right: 1000px;
}
.table-operator .add-group-btn {
  margin-left: 0;
}
</style>
